import React, { useEffect, useState } from "react";
import IncludeSideBar from "../../../Components/Sidebar/IncludeSideBar";
import { getAnalytics } from "../../../apis/dashboard";
import "./Analytics.css";

const AnalyticsOverview = () => {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [period, setPeriod] = useState("daily");

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const response = await getAnalytics(period);
      setAnalytics(response);
      setError(null);
    } catch (err) {
      console.error("Error fetching analytics:", err);
      setError("Failed to load analytics data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, [period]);

  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "N/A";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) return `${hours}h ${minutes}m`;
    if (minutes > 0) return `${minutes}m ${secs}s`;
    return `${secs}s`;
  };

  const formatWatchTime = (seconds) => {
    if (!seconds && seconds !== 0) return "N/A";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
  };

  return (
    <IncludeSideBar>
      <div className="analytics-page">
        <h2>Analytics Overview</h2>
        
        <div className="period-selector">
          <label>Select Period:</label>
          <select value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="loader"></div>
            <p>Loading analytics...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p>{error}</p>
            <button onClick={fetchAnalytics}>Retry</button>
          </div>
        ) : (
          <div className="analytics-grid">
            <div className="analytics-card">
              <div className="card-icon dau-icon">📊</div>
              <div className="card-content">
                <h3>DAU</h3>
                <p className="card-value">{analytics?.dau ?? 0}</p>
                <p className="card-label">Daily Active Users</p>
              </div>
            </div>

            <div className="analytics-card">
              <div className="card-icon wau-icon">📈</div>
              <div className="card-content">
                <h3>WAU</h3>
                <p className="card-value">{analytics?.wau ?? 0}</p>
                <p className="card-label">Weekly Active Users</p>
              </div>
            </div>

            <div className="analytics-card">
              <div className="card-icon mau-icon">📉</div>
              <div className="card-content">
                <h3>MAU</h3>
                <p className="card-value">{analytics?.mau ?? 0}</p>
                <p className="card-label">Monthly Active Users</p>
              </div>
            </div>

            <div className="analytics-card">
              <div className="card-icon duration-icon">⏱️</div>
              <div className="card-content">
                <h3>Avg Session</h3>
                <p className="card-value">{formatDuration(analytics?.avgSessionDuration)}</p>
                <p className="card-label">Average Session Duration</p>
              </div>
            </div>

            <div className="analytics-card">
              <div className="card-icon videos-icon">🎬</div>
              <div className="card-content">
                <h3>Avg Videos</h3>
                <p className="card-value">{analytics?.avgVideosWatched ?? 0}</p>
                <p className="card-label">Average Videos per User</p>
              </div>
            </div>

            <div className="analytics-card">
              <div className="card-icon peak-icon">⏰</div>
              <div className="card-content">
                <h3>Peak Hour</h3>
                <p className="card-value">
                  {analytics?.peakActivityHour !== undefined 
                    ? `${analytics.peakActivityHour}:00` 
                    : "N/A"}
                </p>
                <p className="card-label">Peak Activity Hour</p>
              </div>
            </div>

            <div className="analytics-card full-width">
              <div className="card-icon watchtime-icon">🎥</div>
              <div className="card-content">
                <h3>Total Watch Time</h3>
                <p className="card-value">{formatWatchTime(analytics?.totalWatchTime)}</p>
                <p className="card-label">Total Watch Time</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </IncludeSideBar>
  );
};

export default AnalyticsOverview;
